import { Component } from '@angular/core';
import { ContaContabil } from '../../../../types/ContaContabil.type';
import { ContascontabeisService } from './contascontabeis.service';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-contascontabeis',
  templateUrl: './contascontabeis.component.html',
  styleUrl: './contascontabeis.component.css'
})
export class ContascontabeisComponent {

  contaContabeis: ContaContabil[] = []
  loading: boolean = false;
  loadingSincronizar: boolean = false;

  constructor(private contaContabeisService: ContascontabeisService, private toastService: ToastService) { }


  ngOnInit() {

    this.getAll()

  }

  getAll() {
    this.loading = true;

    this.contaContabeisService.getContasContabeis().subscribe({
      next: (data) => {
        this.contaContabeis = data;
        this.loading = false;
      },
      error: (error) => {
        this.toastService.erro("Erro ao buscar", error);
        this.loading = false;
      }
    })
  }


  exportar() {

    this.loadingSincronizar = true;

    this.contaContabeisService.exportar().subscribe({
      next: (value) => {
        const url = window.URL.createObjectURL(value);
          const a = document.createElement('a')
          a.href = url
          a.download = 'contas-contabeis.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
      },
      error: (error) => {
        this.toastService.erro("Exportar", `Erro ao exportar: ${error.error}`);
        this.loadingSincronizar = false;
      },
      complete: () => {
        this.loadingSincronizar = false;
      }
    })
  }

}
